import { useTranslations } from "next-intl";

export function AuthFeatures() {
  const t = useTranslations("components.auth_features");

  return (
    <ul className="mt-2 space-y-2 text-sm text-gray-500">
      <li>{t("feature_1")}</li>
      <li>{t("feature_2")}</li>
      <li>{t("feature_3")}</li>
    </ul>
  );
}
